export default __webpack_public_path__ + "static/media/11.0a0d4bd5.jpg";